import { cn } from "@/lib/utils";

// The device's visual mark — the brand spark on its amber tile. Callers set
// the size (size-8, size-9, …).
export function SparkTile({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        "flex shrink-0 items-center justify-center rounded-lg border border-spark/30 bg-spark/10 text-spark",
        className,
      )}
    >
      ✦
    </div>
  );
}
